module.exports = __webpack_public_path__ + "media/site_templates/www.hirecleaners.com.au/images/our_services_2-69c9cb1c8b85e7b430bfc98e922eb311.jpg";